<template>
  <div class="min-h-screen flex flex-col">
    <TopHeader class="max-lg:hidden" />

    <div class="container flex-1 flex flex-col">
      <MediaHeader class="max-lg:mt-5" />

      <main class="flex-1 max-md:px-3.75">
        <router-view />
      </main>

      <MediaNav />
    </div>

    <TheFooter />
    <PageUpButton />
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue'
import TheFooter from '@/components/TheFooter.vue'
import MediaHeader from '@/components/media/MediaHeader.vue'
import MediaNav from '@/components/media/MediaNav.vue'
import PageUpButton from '@/components/PageUpButton.vue'
import { updateLastSeen } from '@/helpers'

export default {
  name: 'MediaLayout',
  components: {
    TopHeader,
    TheFooter,
    MediaHeader,
    MediaNav,
    PageUpButton,
  },

  watch: {
  '$route.name': {
    immediate: true,
    handler(name) {
      const map = {
        announcements: 'announcements',
        businessAccounts: 'business_accounts',
        videos: 'videos',
        publications: 'publications',
        payments: 'payments',
        publishedPublications: 'published_publications',
        rejectedPublications: 'rejected_publications',
      }

      const key = map[name]
      if (key) updateLastSeen(key)
      else console.log('No lastSeen map for route:', name)
    },
  },
},
}
</script>